export const favorites = {
  put: 'customerEndpoint/customer/favorite',
  get: 'customerEndpoint/customer/favorite'
};
